import { render, staticRenderFns } from "./landmarkShopChild.vue?vue&type=template&id=1afc76ed&scoped=true&"
import script from "./landmarkShopChild.vue?vue&type=script&lang=ts&"
export * from "./landmarkShopChild.vue?vue&type=script&lang=ts&"
import style0 from "./landmarkShopChild.vue?vue&type=style&index=0&id=1afc76ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc76ed",
  null
  
)

export default component.exports